export default __webpack_public_path__ + "static/media/noData.3e431af5.png";